import { Chip } from '@mui/material'
import DeleteConfirmationModal from 'commonComponents/DeleteConirmationModel';
import { capitalizeFirstLetter } from 'commonComponents/FirstLetterCaptial'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { deleteMachineById } from '../redux/dispatcher';


// Single Row Data Reperesent Component
function RowData({ itemInfo, handleEdit, handleDelete, handleView, currentPage, rowsPerPage }) {
    const [modalOpen, setModalOpen] = useState(false);
    const [itemId, setItemId] = useState(null);

    const { data } = useSelector((state) => state.authReducer);
    const { isLoading } = useSelector((state) => state.machineListReducer);

    const toggleModal = () => setModalOpen(!modalOpen);
    const dispatch = useDispatch()
    const handleDeleteClick = (id) => {
        setItemId(id); // Set the id to be deleted
        toggleModal(); // Open the modal
    };

    const handleDeleteConfirm = () => {
        const payload = {
            id: itemInfo?.machine_id,
            currentPage,
            rowsPerPage,
        }
        dispatch(deleteMachineById(payload, toggleModal))
    };
    return (
        <>
            <tbody>
                <tr className="align-items-center text-center" >
                    <td>{itemInfo?.serial_number}</td>
                    <td>{itemInfo?.machine_name}</td>
                    <td>{itemInfo?.model}</td>
                    <td>{itemInfo.size}</td>
                    <td>{itemInfo?.machine_number}</td>
                    <td>{itemInfo?.companyName}</td>
                    <td className={itemInfo?.status === 'active' ? 'text-success' : 'text-danger'}>
                        {
                            itemInfo?.status === 'active' ? <Chip label={capitalizeFirstLetter(itemInfo?.status)} color="success" sx={{ p: 1 }} /> : <Chip label={capitalizeFirstLetter(itemInfo?.status)} color="error" />
                        }


                    </td>
                    <td style={{ padding: '0px' }}>
                        {/* <div className='d-flex d-flex justify-content-around '>
                            <i class="fa-solid fa-eye icon_hover" onClick={() => handleView(itemInfo?.machine_id)}></i>
                            <i class="fa-solid fa-pen icon_hover" onClick={() => handleEdit(itemInfo?.machine_id)}></i>
                            <i class="fa-solid fa-trash icon_hover" onClick={() => handleDelete(itemInfo?.machine_id)}></i>
                        </div> */}
                        <div>
                            <i className="fa-solid fa-eye icon_hover" onClick={() => handleView(itemInfo?.machine_id)} style={{ marginRight: '16px' }}></i>
                            <i className="fa-solid fa-pen icon_hover" onClick={() => handleEdit(itemInfo?.machine_id)} ></i>
                            {
                                data?.user?.role === "super_admin" && (
                                    <i className="fa-solid fa-trash icon_hover ml-3" onClick={() => handleDeleteClick(itemInfo?.uuid)}></i>
                                )}
                        </div>
                    </td>
                </tr>
            </tbody>
            <DeleteConfirmationModal
                isOpen={modalOpen}
                toggle={toggleModal}
                onConfirm={handleDeleteConfirm}
                itemName={`machine`}
                isLoading={isLoading}
            />
        </>
    )
}

export default RowData
